module.exports = __webpack_public_path__ + "static/media/znak-blisko@3x.318ff01f.png";